import { render, staticRenderFns } from "./ColorIndicationDialog.vue?vue&type=template&id=8adac458&scoped=true&"
import script from "./ColorIndicationDialog.vue?vue&type=script&lang=js&"
export * from "./ColorIndicationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ColorIndicationDialog.vue?vue&type=style&index=0&id=8adac458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adac458",
  null
  
)

export default component.exports